import React from 'react';
import styled from 'styled-components';
import { Avatar } from '@prezi/avatar';
import { UserDisplayContainer, UserDisplayName, UserDisplayCaption } from '@prezi/common-components';
import highlightText from '../../../utils/highlight';
import { createDataLookup } from '../../const';
const Wrap = styled.div.withConfig({
  displayName: "HighlightOption__Wrap",
  componentId: "sxlg9j-0"
})(["display:flex;"]);
export default (({
  name,
  email,
  currentInput
}) => {
  const names = name.split(' ');
  const firstName = highlightText(names[0], currentInput);
  const lastName = highlightText(names[names.length - 1], currentInput);
  const caption = highlightText(email.toString(), currentInput);
  return React.createElement(Wrap, {
    "data-lookup": createDataLookup('user-autocomplete-option')
  }, React.createElement(Avatar, {
    size: 30,
    firstName: names[0],
    lastName: names[names.length - 1]
  }), React.createElement(UserDisplayContainer, null, React.createElement(UserDisplayName, {
    size: 14
  }, firstName, firstName && lastName ? ' ' : '', lastName), React.createElement(UserDisplayCaption, {
    size: 14
  }, caption)));
});